import { MenuIcon, LogoIcon } from '@/shared/components/icons';

interface HeaderProps {
  onMenuClick?: () => void;
}

export function Header({ onMenuClick }: HeaderProps) {
  return (
    // Mobile-only header: hidden on lg+ screens
    <header className="flex h-14 items-center border-b border-border bg-card px-4 lg:hidden">
      <div className="flex items-center gap-3">
        <button
          onClick={onMenuClick}
          className="rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors"
          aria-label="Открыть меню"
        >
          <MenuIcon className="h-5 w-5" />
        </button>
        <LogoIcon className="h-6 w-6 text-foreground" />
      </div>
    </header>
  );
}
